module.exports = __webpack_public_path__ + "img/edit_task.22779636.svg";